import src from "IMAGE";
export default { src, width: 357, height: 357, blurWidth: 0, blurHeight: 0};
